import { createFileRoute } from '@tanstack/react-router'
import { AiChatPage } from '../../components/pages/AiChatPage'

export const Route = createFileRoute('/_auth_required/')({
  validateSearch: (search: Record<string, unknown>): { aiChatSessionId?: string } => {
    return {
      aiChatSessionId: typeof search.aiChatSessionId === 'string' ? search.aiChatSessionId : undefined,
    }
  },
  component: AiChatPage,
})
